import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/StatusBits";
import { AskMeButton } from "@/components/AiQuestions";

const TONES = [["friendly", "Friendly"], ["professional", "Professional"], ["firm", "Firm"]];

export const CallBrief = ({ value, onChange, mode }) => {
  const [more, setMore] = useState(false);
  const set = (k) => (e) => onChange({ ...value, [k]: e?.target ? e.target.value : e });
  const tone = value.tone || "professional";
  return (
    <div className="space-y-3" data-testid="call-brief">
      <Field label="Goal of the call">
        <Textarea rows={2} data-testid="brief-goal" value={value.goal || ""} onChange={set("goal")} placeholder="e.g. Let them know their approval for {approval_amount} expires Friday" />
      </Field>
      <Field label="What I want to accomplish">
        <Textarea rows={2} data-testid="brief-accomplish" value={value.accomplish || ""} onChange={set("accomplish")} placeholder="e.g. Book a time today to sign the documents" />
      </Field>
      <div>
        <span className="text-xs font-medium text-slate-600">Tone</span>
        <div className="flex gap-1.5 mt-1">
          {TONES.map(([v, l]) => (
            <button key={v} type="button" data-testid={`brief-tone-${v}`} onClick={() => set("tone")(v)}
              className={`px-3 py-1.5 rounded-full text-xs border transition-colors duration-200 ${tone === v ? "bg-zinc-900 text-white border-zinc-900" : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"}`}>{l}</button>
          ))}
        </div>
      </div>
      <p className="text-[11px] text-slate-500">
        {mode === "message" ? "The AI writes a personal recorded message for each contact from this." : "The AI writes the opening line and handles the conversation from this. The contact's account details are included automatically."}
      </p>
      <AskMeButton
        brief={{ kind: mode === "message" ? "message" : "ai", purpose: value.goal || "", goal: value.accomplish || "", tone, method: value.context || "" }}
        onAnswers={(qa) => onChange({ ...value, context: [value.context, ...qa.map((x) => `${x.q} ${x.a}`)].filter(Boolean).join("\n") })}
      />
      {value.context && <p className="text-[11px] text-slate-600 whitespace-pre-wrap rounded bg-slate-50 p-2" data-testid="brief-context-preview">{value.context}</p>}
      <button type="button" className="flex items-center gap-1 text-xs text-slate-600" data-testid="brief-more-toggle" onClick={() => setMore(!more)}>
        {more ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />} More details (optional)
      </button>
      {more && (
        <div className="space-y-3">
          <Field label="Extra details for this call"><Textarea rows={2} data-testid="brief-context" value={value.context || ""} onChange={set("context")} /></Field>
          {mode !== "message" && <Field label="Exact opening line" hint="Leave empty to let the AI write it"><Input data-testid="brief-opening" value={value.opening_line || ""} onChange={set("opening_line")} /></Field>}
          {mode !== "message" && <Field label="Special instructions"><Textarea rows={2} data-testid="brief-special" value={value.special_instructions || ""} onChange={set("special_instructions")} /></Field>}
          {mode !== "message" && <Field label="Callback / follow-up instructions"><Textarea rows={2} data-testid="brief-callback" value={value.callback_instructions || ""} onChange={set("callback_instructions")} /></Field>}
        </div>
      )}
    </div>
  );
};
